import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-popup-benefit',
  template: `
    <div class="benefit__item">
      <img class="benefit__item--icon" [src]="src" />
      <div class="benefit__item--heading">{{ heading }}</div>
      <p class="benefit__item--text">{{ text }}</p>
    </div>
  `,
  styles: `
    .benefit {
      &__item {
        text-align: center;

        &--heading {
          font-size: 12px;
          font-weight: bold;
          margin-top: 10px;
        }

        &--text {
          font-size: 10px;
        }

        &--icon {
          width: 25px;
          height: 35px;
        }
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopupBenefitComponent {
  @Input({ required: true }) src: string;
  @Input({ required: true }) heading: string;
  @Input({ required: true }) text: string;
}
